import { EventEmitter } from 'events';

import { TagService } from './services/tag.service';
import { UserService } from './services/user.service';

const STORAGE_NAME = 'ANNOTATORx2018';

class AppController extends EventEmitter {
    constructor() {
        super();
        this.user = null;

        this.tagService = new TagService({apiUrl: '/api'});
        this.userService = new UserService({apiUrl: '/api'});

        this.userTags = [];
        this.systemTags = [];
        this.tags = [];

        this.tagService.getSystemTags().then(response => {
            if(response.status == 200) {
                this.systemTags = response.data;
                this.updateTags();
            }
        });

        this.checkLoginState();
    }

    getUser() {
        return this.user;
    }

    setUser() {
        console.log("SET USR");
    }

    getTags() {
        let tags = [];

        tags = this.systemTags.concat(this.userTags);

        tags.forEach(tag => {
            Object.defineProperties(tag, {
                value: { 
                    value: tag.name,
                    enumerable: true 
                },
                label: { 
                    value: tag.name,
                    enumerable: true 
                }
            });
        });

        return tags;
    }
    

    login(username, password) {
        this.userService.login(username, password).then(response => {
            if(response.status === 200) {
                this.user = response.data;
                localStorage.setItem(STORAGE_NAME, JSON.stringify({user: this.user}));
                this.getUserTagsDB();
            }
        });
    }

    logout() {
        console.log("LOGOUT");
        localStorage.removeItem(STORAGE_NAME);
        this.user = null;
        this.updateUser();
    }

    checkLoginState() {
        let storageItem = JSON.parse(localStorage.getItem(STORAGE_NAME));
        
        if(storageItem === null) {
            return;
        }

        if(storageItem.user === null) {
            return;
        }

        console.log(storageItem);

        this.user = storageItem.user;
    }

    getUserTagsDB() {
        this.tagService.getUserTags(this.user.id).then(response => {
            this.userTags = response.data;
            this.updateUser();
            this.updateTags();
        });
    }

    updateTags() {
        this.emit('updateTags');
    }

    updateUser() {
        this.emit('updateUser');
    }
}

export default AppController;


// WEBPACK FOOTER //
// src/app.controller.js